<template>
    <div>
        <div class="page-group-title"><span>基础信息</span></div>
        <div class="page-list-box">
            <el-alert title="重要提示" type="warning" show-icon>
                <div class="message">
                    <p>
                        当前只能设置人民币兑美元的汇率，最多精确到小数点后4位。
                    </p>
                    <p>
                        该汇率影响英文站用户按美元实际支付的价格，
                        <span>由于英文站使用Paypal结算，存在较高的手续费，因此建议考虑酌情上调汇率。</span>
                    </p>
                    <p>
                        请注意：该汇率不会自动根据权威数据自动调整，需人工调整。
                    </p>
                </div>
            </el-alert>
            <el-row :gutter="20">
                <el-col
                    v-for="(item, index) in exchangeRateList"
                    :key="index"
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                >
                    <el-card shadow="always">
                        <div class="clearfix">
                            <span class="fl"
                                >1CNY={{ item.rate }}{{ item.code }}</span
                            >
                            <el-button
                                v-if="$utils.have('/exchangeRate/edit')"
                                type="text"
                                class="fr"
                                size="mini"
                                icon="el-icon-edit"
                                @click="edit(item)"
                                >修改</el-button
                            >
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <exchange-rate-edit ref="exchangeRateEdit" @update="updatePage"></exchange-rate-edit>
            
        </div>
        <div class="page-group-title"><span>历史记录</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column
                    prop="objectName"
                    label="外币"
                    width="80"
                ></el-table-column>
                <el-table-column prop="desc" label="日志详情"></el-table-column>
                <el-table-column
                    prop="createUserName"
                    label="操作人"
                    width="200"
                ></el-table-column>
                <el-table-column
                    prop="createTime"
                    label="操作时间"
                    width="180"
                ></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import ExchangeRateEdit from "./components/edit";
export default {
    components: { ExchangeRateEdit },
    data() {
        return {
            exchangeRateList: null,
            data: null,
            dataList: null,
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: false,
        };
    },
    mounted() {
        this.getExchangeRateList();
        this.getDataList();
    },
    methods: {
        //获取汇率列表
        getExchangeRateList() {
            this.$request({
                url: "/exchangeRate/list",
                method: "POST",
                data: {},
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.exchangeRateList = result;
                    } else {
                        this.$message.error(msg || "汇率列表信息请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("汇率列表信息请求错误");
                });
        },
        //修改
        edit(data) {
            this.$refs.exchangeRateEdit.show(data);
        },
        //获取历史记录
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/exchangeRate/log/pageList",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "历史记录请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("历史记录请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },

        //更新页面数据
        updatePage(){
            this.getExchangeRateList();
            this.getDataList();
        }
    },
};
</script>

<style lang="scss" scoped>
.el-card {
    margin: 10px 0;
    line-height: 28px;
}
.message {
    span {
        color: $--color-theme;
    }
}
</style>